import { OrderResponse, Order } from '@b2b/features/order/utilities/order.model';
import { GetCartResponse } from '@b2b/features/cart/utilities/cart.model';

export function normalizeOrder(cart: GetCartResponse[]): Order[] {
  return cart.map(c => ({
    ...c,
  }));
}

export function normalizeOrderForUI(orders: OrderResponse[]): OrderResponse[] {
  return orders;
}
